import { RG_TYPE as r, DOOR_TYPE as e } from "@project-rouge/rg-core";
const D = (o) => o.type !== r.Door ? !1 : o.data.doorType === e.Double;
export {
  D as isDoubleDoor
};
//# sourceMappingURL=index3.js.map
